import { Button, Form, Input, Modal } from "antd";
import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { GoogleLogin } from "@react-oauth/google";
import { useLoginLogic } from "../../utilities/hooks/useLoginLogic";
import { isIOS } from "../../utilities/helper";
import { useTranslation } from "react-i18next";

interface LoginFormModalProps {
  visible: boolean;
  onClose: () => void;
  onSuccess: (token: string) => void;
}

const LoginFormModal: React.FC<LoginFormModalProps> = ({ visible, onClose, onSuccess }) => {
  const { t } = useTranslation();
  const { loginWithEmail, loginWithGoogle, loading, contextHolder } = useLoginLogic();
  const [form] = Form.useForm();

  const handleEmailLogin = async (values: any) => {
    const result = await loginWithEmail(values.email, values.password);
    if (result.success && result.token) {
      onSuccess(result.token);
    }
  };

  const handleGoogleLogin = async (credential: string) => {
    const result = await loginWithGoogle(credential);
    if (result.success && result.token) {
      onSuccess(result.token);
    }
  };

  return (
    <>
      {contextHolder}
      <Modal open={visible} onCancel={onClose} footer={null} centered width={500} title={<span className="text-lg font-bold">{t("login.title")}</span>}>
        <Form form={form} name="sdk-login" className="mt-4" initialValues={{ remember: true }} onFinish={handleEmailLogin} autoComplete="off" layout="vertical">
          <Form.Item
            label={<span className="text-xs">{t("login.inputs.email.label")}</span>}
            name="email"
            required={false}
            className="text-white"
            rules={[{ required: true, type: "email", message: t("login.inputs.email.required") }]}
          >
            <Input prefix={<MailOutlined />} size="large" placeholder={t("login.inputs.email.placeHolder")} />
          </Form.Item>

          <Form.Item
            className="text-white"
            label={<span className="text-xs">{t("login.inputs.password.label")}</span>}
            name="password"
            required={false}
            rules={[{ required: true, message: t("login.inputs.password.required") }]}
          >
            <Input.Password prefix={<LockOutlined />} placeholder={t("login.inputs.password.placeHolder")} size="large" />
          </Form.Item>

          <Form.Item className="w-full flex flex-col mt-[15px]">
            <Button loading={loading} type="primary" size="large" className="w-full mb-3 font-bold text-white bg-primary" htmlType="submit">
              {t("login.button")}
            </Button>

            {/* {!isIOS() && ( */}
            <GoogleLogin
              size="large"
              theme="outline"
              auto_select={false}
              shape="pill"
              ux_mode="popup"
              logo_alignment="center"
              containerProps={{
                className: "!p-0 !w-full google-container",
              }}
              text="continue_with"
              useOneTap={false}
              onSuccess={(tokenResponse: any) => {
                if (tokenResponse && tokenResponse.credential) {
                  handleGoogleLogin(tokenResponse.credential);
                }
              }}
              onError={() => {}}
            />
            {/* )} */}
          </Form.Item>

          <div className="flex flex-col items-center justify-center w-full gap-2 mt-3 text-xs text-gray-600">
            <span>By continuing, you agree to our</span>
            <div className="flex items-center justify-center w-full gap-2">

            <a className="text-primary hover:underline" href={"https://app.shaku.tech/terms_conditions.html"} target="_blank" rel="noopener noreferrer">
              Terms of Service
            </a>
            <span>&</span>
            <a className="text-primary hover:underline" href={"https://app.shaku.tech/privacy_policy.html"} target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default LoginFormModal;
